import { render, staticRenderFns } from "./navdetail.vue?vue&type=template&id=689cf3ea&scoped=true"
import script from "./navdetail.vue?vue&type=script&lang=js"
export * from "./navdetail.vue?vue&type=script&lang=js"
import style0 from "./navdetail.vue?vue&type=style&index=0&id=689cf3ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "689cf3ea",
  null
  
)

export default component.exports